import { gql } from '@apollo/client'

const REQUEST_FIELDS = `
  _id personId requestedMinutes reason status grantedMinutes decidedAt
  decisionReason idempotencyKey createdAt
`

export const GET_MY_ADDITIONAL_TIME_REQUESTS = gql`
  query getMyAdditionalTimeRequests {
    getMyAdditionalTimeRequests {
      ${REQUEST_FIELDS}
      company { _id name }
      project { _id name }
      category { _id name }
    }
  }
`

export const GET_ADDITIONAL_TIME_REQUESTS = gql`
  query getAdditionalTimeRequests {
    getAdditionalTimeRequests {
      ${REQUEST_FIELDS}
      requester { _id firstName lastName }
      company { _id name }
      project { _id name }
      category { _id name }
      audit { type at reason previousMinutes newMinutes }
    }
  }
`

export const ADDITIONAL_TIME_REQUEST_CREATE = gql`
  mutation additionalTimeRequestCreate($input: AdditionalTimeRequestCreateInput!) {
    additionalTimeRequestCreate(input: $input) { ${REQUEST_FIELDS} }
  }
`

export const ADDITIONAL_TIME_REQUEST_DECIDE = gql`
  mutation additionalTimeRequestDecide($id: ID!, $input: AdditionalTimeRequestDecisionInput!) {
    additionalTimeRequestDecide(id: $id, input: $input) { ${REQUEST_FIELDS} }
  }
`
